import {
  Component,
  ElementRef,
  EventEmitter,
  HostListener,
  Input,
  Output,
  QueryList,
  SimpleChanges,
  ViewChildren
} from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { KeyPair } from '../../../../models/base';
import {
  CompanyEarningConfig,
  EarningCalculations
} from '../../../../models/company-earning-config';
import { JobCode, LaborAllocationTypes } from '../../../../models/labor-allocation';
import {
  AllocatedEarning,
  EmployeePay,
  LaborAllocation,
  Payline
} from '../../../../models/payroll';
import { PayrollManagement } from '../../../../tools/payroll-management';
import * as _ from 'underscore';
import { CompaniesService } from '../../../../services/companies.service';

@Component({
  selector: 'lib-edit-rate-modal',
  templateUrl: './edit-rate-modal.component.html',
  standalone: false
})
export class EditRateModalComponent {
  @Input() public SalaryValue: number;
  @Input() public RegValue: number;

  @Input() public PersonName: string;
  @Input() public IsAdd: boolean;

  @Output()
  public save = new EventEmitter<EditRateModalResult>();

  constructor(public activeModal: NgbActiveModal) {}

  get allocTypes() {
    return LaborAllocationTypes;
  }

  get editTitle() {
    return this.IsAdd ? 'Add' : 'Edit';
  }

  ngOnInit() {}

  // #region public methods

  // use plus operator to force number type
  // input will assign empty string when textbox is empty,
  // we want zero in that case

  public onSave(modal) {
    this.save.emit({
      SalaryValue: +this.SalaryValue,
      RegValue: +this.RegValue
    });
    modal.close();
  }

  // #endregion
}

export class EditRateModalResult {
  SalaryValue: number;
  RegValue: number;
}
